module.exports = __webpack_public_path__ + "static/media/2 (40).11322c23.jpg";